import {call, put, select} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {notificationListError, notificationListSuccess} from "store/reducer/notifications/list/reducer";
import {notificationListCurrentPage} from "store/reducer/notifications/list/selectors";
export function* notificationListSaga() {
    try {
        const page = yield select(notificationListCurrentPage);
        const data = yield call([api, api.getNotificationListApi], page);
        yield put(notificationListSuccess(data));
    } catch (e) {
        yield put(notificationListError(getErrorFromMessage(e)))
    }
}